import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ActivityServiceService } from 'src/app/services/activity-service.service';
import { ExcelService } from 'src/app/services/excel.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-manage-activity',
  templateUrl: './manage-activity.component.html',
  styleUrls: ['./manage-activity.component.scss']
})
export class ManageActivityComponent implements OnInit {
  searchform:FormGroup;
  data = [];
  dataSource = new MatTableDataSource(this.data);
  dataExcel: any = [];
  excelColumns: string[];
  displayedColumns: string[] = [
    "ActivityName",
    "EmailRequired",
    "action"
  ];

  constructor(
    private formBuilder:FormBuilder,
    private activityService:ActivityServiceService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private navigationService: NavigationService,

  ) { }

  ngOnInit(): void {
    this.searchform = this.formBuilder.group({
      activityName: [null,Validators.required],
    })
    this.getTableData(null)

  }


  getTableData(data){
    this.activityService.getActivityList(data).subscribe((result)=>{
    this.data = result;
    this.dataExcel = result;
    this.dataSource = new MatTableDataSource(this.data);
  })

  }
  search(){
    if(this.searchform.valid){
      let value =this.searchform.value;
      this.getTableData(value);
    }
  }

  clearFilter(){
    this.getTableData(null)
    this.searchform.reset();
  }
  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "ActivityName",
        "EmailRequired",
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          "ActivityName":a.activityName,
          "EmailRequired":a.isEmailRequired,

        });
      });
      this.excelService.exportAsExcelFile(excelList, "Activity_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  gotoaddactivity(data){
this.navigationService.gotoaddActivity(data);
  }


  deleteProduct(data){
    const txt = 'Are you sure want to Delete this record '
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF3E30',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.activityService.deleteActivity(data).subscribe((result) => {
          if (result) {
            this.toastr.showSuccess("Deleted Successfully");
            this.clearFilter()
          }
          else
            this.toastr.showError("Sorry, something went wrong!!");
        })
      }
    });

  }
}
